import { userConstant } from "./constant"

export const bookTypeAction = (payload) => ({
    type: userConstant.BOOK_TYPE,
    payload: payload
})

export const contentTypeAction = (payload) => ({
    type: userConstant.HTML_CONTENT,
    payload: payload
})
export const nameAction = (payload) => ({
    type: userConstant.HTML_NAME,
    payload: payload
})

export const instructorMainBookAction = (payload) => ({
    type: userConstant.MAIN_BOOK_ID,
    payload: payload
})

export const customArraySequenceAction = (payload) => ({
    type: userConstant.CUSTOM_ARRAY,
    payload: payload
})
export const regularExpressArraySequenceAction = (payload) => ({
    type: userConstant.REG_EXP_ARRAY,
    payload: payload
})